export const leadingZeroLocales = ['en-US'];

export default {
    leadingZeroLocales
};
